import { $Color, $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

import { $NumberFamily, NumberFamily } from './number-family';

const $ = 'MathObjective';

export const MathObjective = {
  NumberSense: tagEnum($, 1),
  PlaceValue: tagEnum($, 2),
  FactFluency: tagEnum($, 3),
  Decimals: tagEnum($, 4),
  Fractions: tagEnum($, 5),
  Algebra: tagEnum($, 6),
  Testing: tagEnum($, 7),
  ProblemSolving: tagEnum($, 8),
  LateralThinking: tagEnum($, 9),
  Financial: tagEnum($, 10),
  Spacial: tagEnum($, 11),
  Recharge: tagEnum($, 12),
  ReducingAnxiety: tagEnum($, 13),
  Perseverance: tagEnum($, 14),
  Confidence: tagEnum($, 15),
  Discourse: tagEnum($, 16),
} as const;

export type MathObjective = TaggedEnumUnion<typeof MathObjective>;

export const $MathObjective = buildStaticContext({
  [$tag]: $,
  [MathObjective.NumberSense]: {
    value: MathObjective.NumberSense,
    slug: 'number-sense',
    label: 'Number Sense',
    color: $Color.from('#f00'),
  },
  [MathObjective.PlaceValue]: {
    value: MathObjective.PlaceValue,
    slug: 'place-value',
    label: 'Place Value Competency',
    color: $Color.from('#0011ffff'),
  },
  [MathObjective.FactFluency]: {
    value: MathObjective.FactFluency,
    slug: 'fact-fluency',
    label: 'Fact Fluency and Automaticity',
    color: $Color.from('#ffbe00'),
  },
  [MathObjective.Decimals]: {
    ...$NumberFamily.describe(NumberFamily.Decimals),
    value: MathObjective.Decimals,
    label: 'Decimals Readiness and Competency',
  },
  [MathObjective.Fractions]: {
    ...$NumberFamily.describe(NumberFamily.Fractions),
    value: MathObjective.Fractions,
    label: 'Fractions Readiness and Competency',
  },
  [MathObjective.Algebra]: {
    value: MathObjective.Algebra,
    slug: 'algebra',
    label: 'Algebra Readiness',
    color: $Color.from('#b8004dff'),
  },
  [MathObjective.Testing]: {
    value: MathObjective.Testing,
    slug: 'testing',
    label: 'Testing Readiness',
    color: $Color.from('#0873ffff'),
  },
  [MathObjective.ProblemSolving]: {
    value: MathObjective.ProblemSolving,
    slug: 'problem-solving',
    label: 'Problem Solving',
    color: $Color.from('#5e08ffff'),
  },
  [MathObjective.LateralThinking]: {
    value: MathObjective.LateralThinking,
    slug: 'lateral-thinking',
    label: 'Thinking Outside the Box',
    color: $Color.from('#ff00c8ff'),
  },
  [MathObjective.Financial]: {
    value: MathObjective.Financial,
    slug: 'financial',
    label: 'Money and Financial Competency',
    color: $Color.from('#3f8a55ff'),
  },
  [MathObjective.Spacial]: {
    value: MathObjective.Spacial,
    slug: 'spatial',
    label: 'Spatial Reasoning',
    color: $Color.from('#09106bff'),
  },
  [MathObjective.Recharge]: {
    value: MathObjective.Recharge,
    slug: 'recharge',
    label: 'Brain Recharge',
    color: $Color.from('#22dd22'),
  },
  [MathObjective.ReducingAnxiety]: {
    value: MathObjective.ReducingAnxiety,
    slug: 'reducing-anxiety',
    label: 'Reducing Math Anxiety',
    color: $Color.from('#2b0d96ff'),
  },
  [MathObjective.Perseverance]: {
    value: MathObjective.Perseverance,
    slug: 'perseverance',
    label: 'Joyous Perseverance',
    color: $Color.from('#ffae00ff'),
  },
  [MathObjective.Confidence]: {
    value: MathObjective.Confidence,
    slug: 'confidence',
    label: 'Cumulative Confidence',

    color: $Color.from('#ae00ffff'),
  },
  [MathObjective.Discourse]: {
    value: MathObjective.Discourse,
    slug: 'discourse',
    label: 'Facilitating Discourse',
    color: $Color.from('#00cccc'),
  },
} as const);
